export default __webpack_public_path__ + "07611cfb370ac81f1cbc1f7475dc5442.png";